<template>
  <section id="message-admin" v-if="message && message.admin">
    <div class="d-flex justify-content-end pb-4">
      <div :class="conditionClass(message)">
        <div class="mb-1 text-chat-time text-right">
          <template v-if="message.message !== '<Closed>' && !message.assign_to" >
            {{ message.admin.name }}
            {{ message.created_at | chatDateTime }}
          </template>
        </div>
        <message-attachment @onClickAttachment="selectAttachment"
        @onSelectAttachment="selectAttachmentedFile"
        :selectedFile="selectedFile"
        :message="message"
        class="text-right"
        v-if="message.attachments && message.attachments.length > 0"></message-attachment>
        <!-- <message-sticker
                v-if="message.stickers && message.stickers.length > 0"></message-sticker> -->
        <div v-if="message.stickers && message.stickers.length > 0" class="text-right">
          <img v-for="(sticker, index) in message.stickers" :key="index" :src="sticker.sticker_line.url_img" style="width:150px;">
        </div>
        <div v-else style="position:relative; " class="text-small">
          <template v-if="message.message === '<Closed>' || message.assign_to || message.message === '<SetReminder>' ||  message.message === '<CancelReminder>' || message.message === '<Tagged>'">
            <hr :class="['hr-text', message.message === '<SetReminder>' || message.message === '<CancelReminder>' ? 'add-space' : '']" :data-content="convertContentHrLine(message)">
            <div v-if="message.message === '<SetReminder>' || message.message === '<CancelReminder>'" class="set-reminder">
              <span v-if="message.message === '<SetReminder>'">
                Set Reminder {{ moment(message.set_reminder_at).format('DD/MM/YYYY HH:mm') }}
              </span>
              <span v-else-if="message.message === '<Tagged>'">
                Change Tag custom {{ moment(message.created_at).format('DD/MM/YYYY HH:mm') }}
              </span>
              <span v-else>
                Cancel Reminder
              </span>
            </div>
          </template>
          <template v-else>
            <div class="card border-0 admin-chat float-right mw-100 d-inline-block" v-if="message.message !== '<Attachment>'">
              <div class="card-body p-2">
                <div class="text-small" v-html="message.message" v-linkified></div>
                <thai-translation :message="message.message" />
              </div>
            </div>
          </template>
          <div class="clearfix"></div>
        </div>

        <template v-if="(message.message !== '<Closed>' && message.message !== '<Tagged>') && !message.assign_to">
          <div class="text-right text-smaller text-muted pt-2">
            <span v-html="getSentStatus(message)"></span>
            <span class="d-inline-block ml-2">
            <span v-if="message.is_sent === 2">
              <!-- a resend of an over-length message re-queues the identical text and fails again, so
                   the affordance is plain text, not a control. Every other failure keeps the link. -->
              <span v-if="isOverLimitFailure" class="resend-blocked" :title="overLimitDetail">
                ข้อความยาวเกินกำหนด ส่งใหม่ไม่ได้
              </span>
              <a v-else href="" @click.prevent="performResendMessage(message)">ส่งใหม่อีกครั้ง</a>
            </span>
          </span>
          </div>
        </template>

      </div>
      <div class="pl-3" v-if="(message.message !== '<Closed>') && !message.assign_to">
        <div class="fade-in">
          <img
            v-lazy="message.admin.profile_picture"
            class="rounded-circle img-circle"
            alt=""
            width="48"
          />
        </div>
      </div>
    </div>

    <!-- v-if, not :open — BaseToast.mounted() calls syncOpenState(open), so an instance created
         already-open arms its timer. A long transcript must mount none until something fails. -->
    <BaseToast v-if="resendToast.open"
               :open="true"
               variant="danger"
               icon="alert"
               :title="resendToast.title"
               :message="resendToast.message"
               :autoHideDelay="6000"
               @close="resendToast.open = false" />
  </section>
</template>

<script>
import MessageAttachment from './MessageAttachment.vue'
import ThaiTranslation from './components/ThaiTranslation'
import chatHelpers from '../../helpers/chatHelpers'
import BaseToast from './BaseToast.vue'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { countMessageLength, getTextLimit, getPlatformLabel, blockedSendDetail } from '@/constants/messageLimits'

export default {
  props: {
    selectedFile: Array,
    message: Object
  },
  components: {
    MessageAttachment,
    ThaiTranslation,
    BaseToast
  },
  data () {
    return {
      resendToast: { open: false, title: '', message: '' }
    }
  },
  computed: {
    ...mapState('general', ['messageLimits', 'messageLimitLabels']),
    // AdminChat has no conversation prop; it relies on the eager-loaded message.conversation. When
    // that is absent (optimistic / socket-pushed rows) the limit is null and the bubble keeps its
    // normal clickable link.
    failureConversationType () {
      return (this.message && this.message.conversation) ? this.message.conversation.type : null
    },
    failureTextLimit () {
      return getTextLimit(this.failureConversationType, this.messageLimits)
    },
    isOverLimitFailure () {
      if (!this.message || this.message.is_sent !== 2) return false
      if (this.failureTextLimit === null) return false
      return countMessageLength(this.message.message) > this.failureTextLimit
    },
    overLimitDetail () {
      if (!this.isOverLimitFailure) return null
      return blockedSendDetail(
        countMessageLength(this.message.message),
        this.failureTextLimit,
        getPlatformLabel(this.failureConversationType, this.messageLimitLabels)
      )
    }
  },
  methods: {
    ...mapActions('message', ['resendMessage']),
    moment (date) {
      return moment(date)
    },
    hasNoThai (text) {
      return !/[\u0E00-\u0E7F]/.test(text)
    },
    async performResendMessage (message) {
      this.message.is_sent = 0
      const result = await this.resendMessage(message.id)
      // without the revert the bubble spins on "กำลังส่ง" forever
      if (result && result.ok === false) {
        this.message.is_sent = 2
        this.openResendToast(result.message)
      }
    },
    openResendToast (detail) {
      this.resendToast.open = false
      this.$nextTick(() => {
        this.resendToast.title = 'ส่งข้อความใหม่ไม่สำเร็จ'
        this.resendToast.message = detail || ''
        this.resendToast.open = true
      })
    },
    conditionClass (message) {
      let classStyle = 'w-75'
      if (message.message === '<Closed>' || message.assign_to) {
        classStyle = 'w-100'
      }
      return classStyle
    },
    convertContentHrLine (message) {
      let content = ''
      if (message.message === '<Closed>') {
        content = message.admin.name + ` ปิดเคส ${moment(message.created_at).format('DD/MM/YYYY HH:mm')}`
      } else if (message.admin_assign_to) {
        content = message.admin.name + ` Assign to ${message.admin_assign_to.name} ${moment(message.created_at).format('DD/MM/YYYY HH:mm')}`
      } else if (message.message === '<SetReminder>') {
        content = message.admin.name + `${moment(message.created_at).format('DD/MM/YYYY HH:mm')}`
      } else if (message.message === '<CancelReminder>') {
        content = message.admin.name + `${moment(message.created_at).format('DD/MM/YYYY HH:mm')}`
      } else if (message.message === '<Tagged>') {
        content = message.admin.name + ` เลือกหัวข้อ ${message.tag_message} ${moment(message.created_at).format('DD/MM/YYYY HH:mm')}`
      }
      return content
    },
    getSentStatus (message) {
      let html = ''
      switch (message.is_sent) {
        case 0:
          html = '<span>กำลังส่ง...</span>'
          break
        case 1:
          html = '<span><i class="fas fa-check text-success"></i> ส่งแล้ว</span>'
          if (message.conversation && message.conversation.is_read_professional === 1) {
            html = '<span><i class="fas fa-check text-success"></i><i class="fas fa-check text-success"></i> อ่านแล้ว</span>'
          }
          break
        case 2:
          html = '<span><i class="fas fa-times text-danger"></i> ส่งไม่สำเร็จ</span>'
          break
      }
      return html
    },
    selectAttachment (attachment) {
      this.$emit('onSelectAttachment', attachment)
    },
    selectAttachmentedFile (attachment, isChecked) {
      this.$emit('onSelectAttachmentFile', attachment, isChecked)
    },
    getUrlExtension (message) {
      return chatHelpers.getUrlExtension(message.attachments[0].url)
    },
    cssMediaType (message) {
      let cssClass = 'card text-item'
      if (message.attachments && message.attachments.length > 0) {
        const ext = this.getUrlExtension(message)
        switch (ext) {
          case 'jpg':
          case 'gif':
          case 'png':
            cssClass = 'card image-item'
            break
          case 'mp4':
          case 'mp3':
          case 'location':
            cssClass = 'card media-item'
            break
        }
      }
      return cssClass
    }
  }
}
</script>

<style lang="scss" scoped>
.resend-blocked {
  color: #B42318;
  cursor: default;
}
</style>
